import OriginForm from './Form';
import Item from './FormItem';

type FormType = typeof OriginForm & {
  Item: typeof Item;
};

const Form = OriginForm as FormType;
Form.Item = Item;

export default Form;
export * from './interface';
